(() => {
  // ---------- Data ----------
  const GALLERY = ((window.DRIPURR_PDP && window.DRIPURR_PDP.gallery) || [])
    .map(function(g){ return g.src; });
  const GALLERY_ALTS = ((window.DRIPURR_PDP && window.DRIPURR_PDP.gallery) || [])
    .map(function(g){ return g.alt || ''; });
  // Full-bleed variants for the infographic slides — safe text margins, so they
  // can fill the frame (cover) at any stage ratio instead of letterboxing.
  const GALLERY_FULLBLEED = {
    4: "https://cdn.shopify.com/s/files/1/0979/2179/4416/files/dripurr-quiet-cat-fountain-25db-mobile.png?v=1782846837&width=1400",
    5: "https://cdn.shopify.com/s/files/1/0979/2179/4416/files/dripurr-triple-layer-carbon-filter-mobile.png?v=1782846837&width=1400"
  };
  const srcFor = (i) => GALLERY_FULLBLEED[i] || GALLERY[i];

  // Bold lead shows everywhere; detail is hidden on mobile (.b-detail).
  // Kept short enough to fit one line each on desktop.
  // Separator dot is rendered in CSS (.b-detail::before) — keep details bare.
  const BENEFITS = [
    { lead:"Picky cats drink from it", detail:"or your money back" },
    { lead:"Whisper-quiet (<25dB)", detail:"you'll forget it's running" },
    { lead:"Cleans in the dishwasher", detail:"no slime scrubbing" },
    { lead:"Crafted with 304 stainless steel", detail:"on every drinking surface" }
  ];

  const PKGS = [
    { id:"1m", months:1, title:"Fountain Starter", subtitle:"Fountain + 1 month of filters", price:59, compare:88, subPrice:54, refillPrice:12, refillOrig:15,
      perks:["Dripurr fountain","Filters: 1 month","FREE Shipping"] },
    { id:"6m", months:6, title:"6 Month Essential", subtitle:"Fountain + 6 months of filters", price:89, compare:170, subPrice:79, badge:"Most Popular", highlight:true, refillPrice:39.90, refillOrig:57,
      perks:["Dripurr fountain","Filters: 6 months","FREE Bonus Filters: 2 months","FREE Bonus Gift","FREE Shipping"] },
    { id:"12m", months:12, title:"1 Year Hydration Bundle", subtitle:"Fountain + 12 months of filters + Anti-Splash Mat", price:124, compare:249, subPrice:109, refillPrice:68.40, refillOrig:114,
      perks:["Dripurr fountain","Filters: 12 months","FREE Anti-Splash Mat","FREE Bonus Filters: 2 months","FREE Bonus Gift","FREE Shipping"] }
  ];
  PKGS.forEach(p => { p.save = p.compare - p.price; });
  const fmtP = n => Number.isInteger(n) ? String(n) : n.toFixed(2);

  const GIFTS = [
    { label:"Free & Fast Shipping", strike:"$10", img:"https://cdn.shopify.com/s/files/1/0979/2179/4416/files/free-shipping-icon.png?v=1782846837", value:10 },
    { label:"Bonus Gift!",          strike:"$15", img:"https://cdn.shopify.com/s/files/1/0979/2179/4416/files/dripurr-free-bonus-gift-icon.png?v=1784640928",    value:15 },
    { label:"Filters (4-pack)",     strike:"$19", img:"https://cdn.shopify.com/s/files/1/0979/2179/4416/files/free-replacement-filters-icon.png?v=1782846837",  value:19 },
    { label:"Anti-Splash Mat",      strike:"$22", img:"https://cdn.shopify.com/s/files/1/0979/2179/4416/files/free-anti-splash-mat-icon.png?v=1782846837",      value:22 }
  ];

  const FAQS = [
    { icon:"cat",      q:"Will my picky cat actually drink from it?",
      a:"Cats are drawn to flowing water — it's instinct. And with nearly double the activated carbon in our upgraded filters, the water stays cleaner and fresher-tasting — which draws cats in even more. With 4 flow styles (gentle stream, wide bowl, faucet stream, bubble dome), even the pickiest ones usually find a favorite within 1–2 weeks. If yours doesn't take to it in 60 days, send it back — no fee, no questions." },
    { icon:"help",     q:"How loud is it, honestly?",
      a:"Under 25 dB. For reference: your refrigerator runs 40–55 dB. You won't hear it from across the room. If yours hums, gurgles, or rattles, we replace it." },
    { icon:"sparkles", q:"How do I actually clean it — and how often?",
      a:"Once a month, ~5 minutes. The pump comes apart in 3 pieces (no specialized tools). The stainless steel bowl is dishwasher-safe. No tight crevices, no plastic bowl to scrub." },
    { icon:"gem",      q:"Why stainless steel instead of plastic?",
      a:"Plastic gets micro-scratched and builds biofilm where bacteria hide. 304 stainless steel is non-porous, dishwasher-safe, and the gold standard for water hygiene." },
    { icon:"settings", q:"What are the specs?",
      a:"3.2L capacity · 304 stainless steel bowl · <25 dB pump · USB-powered · 4 adjustable flow styles · triple-action carbon filtration." }
  ];

  // Lucide-style icons (inline SVG paths)
  const ICONS = {
    settings: '<path d="M14 17H5"/><path d="M19 7h-9"/><circle cx="17" cy="17" r="3"/><circle cx="7" cy="7" r="3"/>',
    cat:      '<path d="M12 5c.67 0 1.35.09 2 .26 1.78-2 5.03-2.84 6.42-2.26 1.4.58-.42 7-.42 7 .57 1.07 1 2.24 1 3.44C21 17.9 16.97 21 12 21s-9-3-9-7.56c0-1.25.5-2.4 1-3.44 0 0-1.89-6.42-.5-7 1.39-.58 4.72.23 6.5 2.23A9.04 9.04 0 0 1 12 5Z"/><path d="M8 14v.5"/><path d="M16 14v.5"/><path d="M11.25 16.25h1.5L12 17l-.75-.75Z"/>',
    sparkles: '<path d="M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z"/><path d="M20 2v4"/><path d="M22 4h-4"/><circle cx="4" cy="20" r="2"/>',
    help:     '<circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><path d="M12 17h.01"/>',
    gem:      '<path d="M10.5 3 8 9l4 13 4-13-2.5-6"/><path d="M17 3a2 2 0 0 1 1.6.8l3 4a2 2 0 0 1 .013 2.382l-7.99 10.986a2 2 0 0 1-3.247 0l-7.99-10.986A2 2 0 0 1 2.4 7.8l2.998-3.997A2 2 0 0 1 7 3z"/><path d="M2 9h20"/>'
  };

  // ---------- State ----------
  let selectedPkg = "1m";
  let subOn = false;
  let imgIdx = 0;
  let openFaq = null;

  // ---------- Gallery ----------
  const mainImg = document.getElementById('mainImg');
  const thumbsEl = document.getElementById('thumbs');
  GALLERY.forEach((_src, i) => {
    const b = document.createElement('button');
    b.className = 'thumb' + (i === 0 ? ' active' : '');
    b.innerHTML = `<img src="${GALLERY[i].replace('width=1200','width=240')}" loading="lazy" decoding="async" alt="${(GALLERY_ALTS[i]||'').replace(/"/g,'&quot;')}">`;
    b.addEventListener('click', () => setImg(i));
    thumbsEl.appendChild(b);
  });
  // Infographic slides fill the frame when the stage shape keeps their text inside the
  // crop; on extreme stage ratios they letterbox onto a background matched to the art.
  const FIT_BG = { 4:'#0d1420', 5:'#f3ede4' };
  function fitMainImg(){
    const stage = mainImg.parentElement;
    if (FIT_BG[imgIdx] === undefined){ mainImg.style.objectFit = ''; stage.style.background = ''; return; }
    const r = stage.clientWidth / stage.clientHeight;
    const fills = r >= 0.87 && r <= 1.4;
    mainImg.style.objectFit = fills ? 'cover' : 'contain';
    stage.style.background = fills ? '' : FIT_BG[imgIdx];
  }
  window.addEventListener('resize', fitMainImg);
  function setImg(i){
    imgIdx = (i + GALLERY.length) % GALLERY.length;
    // Skip the initial assignment: the server renders slide 0 so the LCP fetch starts before JS runs.
    const want = srcFor(imgIdx);
    if (mainImg.getAttribute('src') !== want) mainImg.src = want;
    if (GALLERY_ALTS[imgIdx]) mainImg.alt = GALLERY_ALTS[imgIdx];
    fitMainImg();
    document.querySelectorAll('.thumb').forEach((t, k) => t.classList.toggle('active', k === imgIdx));
    // Image 1 shows the award flag; every other image shows the filtration pill.
    const flag = document.querySelector('.award-flag');
    if (flag) flag.style.display = imgIdx === 0 ? '' : 'none';
    const pill = document.querySelector('.vet-overlay');
    if (pill) pill.style.display = imgIdx === 0 ? 'none' : '';
  }
  setImg(0);
  document.getElementById('prevImg').addEventListener('click', () => setImg(imgIdx - 1));
  document.getElementById('nextImg').addEventListener('click', () => setImg(imgIdx + 1));

  // ---------- UGC video cards: tap to play / pause ----------
  document.querySelectorAll('.ugc-card.has-video').forEach(card => {
    const video = card.querySelector('.ugc-video');
    const btn = card.querySelector('.ugc-play');
    if (!video || !btn) return;
    btn.addEventListener('click', () => { video.play(); });
    video.addEventListener('play', () => card.classList.add('playing'));
    video.addEventListener('pause', () => card.classList.remove('playing'));
    video.addEventListener('ended', () => { card.classList.remove('playing'); video.currentTime = 0; });
    video.addEventListener('click', () => { if (!video.paused) video.pause(); });
  });

  // ---------- Mobile comparison-chart competitor toggle ----------
  (function(){
    const table = document.querySelector('.vs-table');
    if (!table) return;
    const nameEl = document.getElementById('vsCompName');
    const names = { stainless: 'Stainless lookalikes', typical: 'Plastic fountains' };
    table.querySelectorAll('.vs-mtoggle button').forEach(function(btn){
      btn.addEventListener('click', function(){
        const c = btn.getAttribute('data-c');
        table.setAttribute('data-compare', c);
        table.querySelectorAll('.vs-mtoggle button').forEach(function(b){
          const on = b === btn;
          b.classList.toggle('on', on);
          b.setAttribute('aria-selected', String(on));
        });
        if (nameEl) nameEl.textContent = names[c] || '';
      });
    });
  })();

  // ---------- Mobile announcement marquee — clone slides for seamless loop ----------
  if (window.matchMedia('(max-width: 767px)').matches){
    const annoInner = document.querySelector('.anno-inner');
    if (annoInner){
      Array.from(annoInner.children).forEach(s => {
        const clone = s.cloneNode(true);
        clone.setAttribute('aria-hidden','true');
        annoInner.appendChild(clone);
      });
    }
  }

  // ---------- Mobile hamburger menu ----------
  const hdrMenuBtn = document.getElementById('hdrMenu');
  const hdrDrawer  = document.getElementById('hdrDrawer');
  if (hdrMenuBtn && hdrDrawer){
    const closeDrawer = () => {
      hdrDrawer.classList.remove('open');
      hdrMenuBtn.setAttribute('aria-expanded', 'false');
      hdrDrawer.setAttribute('aria-hidden', 'true');
    };
    hdrMenuBtn.addEventListener('click', () => {
      const isOpen = hdrDrawer.classList.toggle('open');
      hdrMenuBtn.setAttribute('aria-expanded', String(isOpen));
      hdrDrawer.setAttribute('aria-hidden', String(!isOpen));
    });
    hdrDrawer.querySelectorAll('a').forEach(a => a.addEventListener('click', closeDrawer));
  }

  // ---------- Header: search toggle + live cart count ----------
  (function(){
    const hdr = document.querySelector('.hdr');
    const searchBtn = document.getElementById('hdrSearch');
    const searchBar = document.getElementById('hdrSearchBar');
    if (hdr && searchBtn && searchBar){
      searchBtn.addEventListener('click', function(){
        const open = hdr.classList.toggle('hdr-search-open');
        searchBtn.setAttribute('aria-expanded', String(open));
        if (open){ const inp = searchBar.querySelector('input'); if (inp) inp.focus(); }
      });
    }
    const badge = document.getElementById('cartCount');
    if (badge){
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(c){ if (c && c.item_count > 0){ badge.textContent = c.item_count; badge.hidden = false; } })
        .catch(function(){});
    }
  })();

  // ---------- Premium cart drawer ----------
  (function(){
    const drawer = document.getElementById('cartDrawer');
    const overlay = document.getElementById('cdOverlay');
    if (!drawer || !overlay) return;
    const cfg = window.DRIPURR_PDP || {};
    const itemsEl = document.getElementById('cdItems');
    const fmt = function(c){ return '$' + (c/100).toFixed(2); };
    const thumb = function(u, s){ return u ? u.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_'+s+'x$1$2') : ''; };
    let recs = null;
    // map filter variant -> its subscription selling plan + savings %
    const subPct = { "1m": 20, "6m": 30, "12m": 40 };
    const filterInfo = {};
    Object.keys(cfg.filters || {}).forEach(function(t){
      const f = cfg.filters[t];
      if (f && f.variantId && f.sellingPlanId) filterInfo[f.variantId] = { plan: f.sellingPlanId, pct: subPct[t] || 0 };
    });
    // marketing "was" anchor per variant (fountain $79->$59; filters vs one-time retail)
    const compareByVariant = {};
    if (cfg.fountain && cfg.fountain.variantId) compareByVariant[cfg.fountain.variantId] = 7900;
    const filterRetail = { "1m": 950, "6m": 5700, "12m": 11400 };
    Object.keys(cfg.filters || {}).forEach(function(t){
      const f = cfg.filters[t];
      if (f && f.variantId && filterRetail[t]) compareByVariant[f.variantId] = filterRetail[t];
    });

    function setBadge(n){
      const b = document.getElementById('cartCount');
      if (b){ if (n>0){ b.textContent = n; b.hidden = false; } else { b.hidden = true; } }
      const dc = document.getElementById('cdCount'); if (dc) dc.textContent = n;
    }
    function getCart(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(r=>r.json()); }

    // "cart reserved" countdown (persists across the session)
    const RES_KEY='dripurrCartReserve', RES_MS=10*60*1000; let timerInt=null;
    function fmtClock(ms){ const t=Math.max(0,Math.floor(ms/1000)),m=Math.floor(t/60),s=t%60; return (m<10?'0':'')+m+':'+(s<10?'0':'')+s; }
    function reserveEnd(){ let e=parseInt(sessionStorage.getItem(RES_KEY),10); if(!e||e-Date.now()<=0){ e=Date.now()+RES_MS; try{sessionStorage.setItem(RES_KEY,String(e));}catch(x){} } return e; }
    function tickTimer(){ const el=document.getElementById('cdTimerClock'); if(el) el.textContent=fmtClock(reserveEnd()-Date.now()); }
    function startTimer(){ tickTimer(); if(timerInt) clearInterval(timerInt); timerInt=setInterval(tickTimer,1000); }
    function stopTimer(){ if(timerInt){ clearInterval(timerInt); timerInt=null; } }

    function open(){
      overlay.hidden = false;
      requestAnimationFrame(function(){ overlay.classList.add('show'); drawer.classList.add('open'); });
      drawer.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow = 'hidden';
      startTimer();
      render();
    }
    function close(){
      overlay.classList.remove('show'); drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden','true');
      document.documentElement.style.overflow = '';
      stopTimer();
      setTimeout(function(){ if (!drawer.classList.contains('open')) overlay.hidden = true; }, 340);
    }

    function lineHTML(it){
      const cmp = compareByVariant[it.variant_id];
      const orig = Math.max(it.original_line_price, cmp ? cmp * it.quantity : 0);
      const disc = orig - it.final_line_price;
      const price = it.final_line_price === 0
        ? (disc>0 ? '<s>'+fmt(orig)+'</s> <span class="cd-free">FREE</span>' : '<span class="cd-free">FREE</span>')
        : (disc>0 ? '<s>'+fmt(orig)+'</s> <b>'+fmt(it.final_line_price)+'</b>' : '<b>'+fmt(it.final_line_price)+'</b>');
      const variantLine = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cd-item-variant">'+it.variant_title+'</div>' : '';
      const sub = it.selling_plan_allocation ? '<div class="cd-item-sub">Auto-refill &middot; renews until you cancel</div>' : '';
      const save = '';
      const fi = filterInfo[it.variant_id];
      let subOffer = '';
      if (fi && !it.selling_plan_allocation){
      } else if (fi && it.selling_plan_allocation){
        subOffer = '<button class="cd-unsub" data-key="'+it.key+'" data-vid="'+it.variant_id+'" data-plan="" data-qty="'+it.quantity+'" type="button">Switch to one-time purchase</button>';
      }
      const img = thumb(it.image, 128);
      return '<li class="cd-item">'
        + '<div class="cd-item-img">'+(img?'<img src="'+img+'" alt="" loading="lazy">':'')+'</div>'
        + '<div class="cd-item-main"><div class="cd-item-top"><div class="cd-item-title">'+it.product_title+'</div>'
        + '<button class="cd-item-rm" data-key="'+it.key+'" type="button" aria-label="Remove"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2m2 0-.6 12a2 2 0 0 1-2 1.9H8.6a2 2 0 0 1-2-1.9L6 7"/></svg></button></div>'
        + variantLine + sub + '<div class="cd-item-bot"><div class="cd-qty">'
        + '<button class="cd-q" data-key="'+it.key+'" data-d="-1" type="button" aria-label="Decrease">−</button><span>'+it.quantity+'</span>'
        + '<button class="cd-q" data-key="'+it.key+'" data-d="1" type="button" aria-label="Increase">+</button></div>'
        + '<div class="cd-item-price">'+price+'</div></div>' + save + subOffer + '</div></li>';
    }

    function render(){
      return getCart().then(function(cart){
        setBadge(cart.item_count);
        const empty = document.getElementById('cdEmpty');
        const foot = document.getElementById('cdFoot');
        const upsell = document.getElementById('cdUpsell');
        const timer = document.getElementById('cdTimer');
        const ship = document.querySelector('.cd-ship');
        const bannerDisp = cart.item_count === 0 ? 'none' : '';
        if (timer) timer.style.display = bannerDisp;
        if (ship) ship.style.display = bannerDisp;
        if (cart.item_count === 0){
          itemsEl.innerHTML=''; empty.hidden=false; foot.style.display='none'; if(upsell) upsell.hidden=true; return cart;
        }
        empty.hidden=true; foot.style.display='';
        const sorted = cart.items.slice().sort(function(a,b){ return (b.final_line_price - a.final_line_price) || (b.original_line_price - a.original_line_price); });
        itemsEl.innerHTML = sorted.map(lineHTML).join('');
        const totalDisc = cart.items.reduce(function(s,it){
          const c = compareByVariant[it.variant_id];
          const o = Math.max(it.original_line_price, c ? c*it.quantity : 0);
          return s + (o - it.final_line_price);
        }, 0);
        document.getElementById('cdSubtotal').innerHTML =
          (totalDisc>0 ? '<s>'+fmt(cart.total_price + totalDisc)+'</s> ' : '') + fmt(cart.total_price);
        document.getElementById('cdCheckoutTotal').textContent = ' · ' + fmt(cart.total_price);
        const saveEl = document.getElementById('cdSave');
        if (saveEl) saveEl.hidden = true;
        loadUpsell(cart);
        return cart;
      });
    }

    function change(key, qty){
      fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:qty})})
        .then(r=>r.json()).then(function(){ render(); }).catch(function(){});
    }
    function addVariant(vid){
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:Number(vid),quantity:1}]})})
        .then(function(){ render(); }).catch(function(){});
    }

    function loadUpsell(cart){
      const wrap = document.getElementById('cdUpsell');
      const list = document.getElementById('cdUpsellList');
      if (!wrap || !list || !cfg.fountain || !cfg.fountain.productId) return;
      const paint = function(){
        const inCart = {}; cart.items.forEach(function(it){ inCart[it.product_id]=true; });
        const hidden = {15155052085616:1,15152531734896:1,14908225323376:1}; // bundle-gift & legacy SKUs — never upsell
        const show = (recs||[]).filter(function(p){ return p.available && !inCart[p.id] && !hidden[p.id]; }).slice(0,3);
        if (!show.length){ wrap.hidden=true; return; }
        wrap.hidden=false;
        list.innerHTML = show.map(function(p){
          const v = (p.variants&&p.variants[0])||{};
          const img = thumb(p.featured_image || (p.images&&p.images[0]) || '', 100);
          const vt = (v.title && v.title !== 'Default Title') ? '<span class="cd-up-var">'+v.title+'</span> · ' : '';
          return '<div class="cd-up-item"><div class="cd-up-img">'+(img?'<img src="'+img+'" alt="" loading="lazy">':'')+'</div>'
            + '<div class="cd-up-info"><div class="cd-up-title">'+p.title+'</div><div class="cd-up-price">'+vt+fmt(v.price)+'</div></div>'
            + '<button class="cd-up-add" data-vid="'+v.id+'" type="button">Add</button></div>';
        }).join('');
      };
      if (recs){ paint(); return; }
      fetch('/recommendations/products.json?product_id='+cfg.fountain.productId+'&limit=10&intent=related',{headers:{'Accept':'application/json'}})
        .then(function(r){ return r.ok?r.json():{products:[]}; }).then(function(d){ recs = d.products||[]; paint(); }).catch(function(){ recs=[]; });
    }

    drawer.addEventListener('click', function(e){
      const b = e.target.closest('button'); if (!b) return;
      if (b.classList.contains('cd-q')){
        const span = b.parentNode.querySelector('span');
        const q = (parseInt(span.textContent,10)||1) + (b.getAttribute('data-d')==='1'?1:-1);
        change(b.getAttribute('data-key'), Math.max(0,q));
      } else if (b.classList.contains('cd-item-rm')){ change(b.getAttribute('data-key'),0); }
      else if (b.classList.contains('cd-sub-offer') || b.classList.contains('cd-unsub')){
        const key=b.getAttribute('data-key'), vid=b.getAttribute('data-vid'), plan=b.getAttribute('data-plan'), qty=Number(b.getAttribute('data-qty'))||1;
        b.disabled = true;
        const H={'Content-Type':'application/json','Accept':'application/json'};
        const addItem = plan ? {id:Number(vid),quantity:qty,selling_plan:Number(plan)} : {id:Number(vid),quantity:qty};
        fetch('/cart/change.js',{method:'POST',headers:H,body:JSON.stringify({id:key,quantity:0})})
          .then(function(){ return fetch('/cart/add.js',{method:'POST',headers:H,body:JSON.stringify({items:[addItem]})}); })
          .then(function(){ render(); }).catch(function(){ render(); });
      }
      else if (b.classList.contains('cd-up-add')){ addVariant(b.getAttribute('data-vid')); }
      else if (b.id==='cdClose' || b.id==='cdEmptyClose'){ close(); }
    });
    overlay.addEventListener('click', close);
    document.addEventListener('keydown', function(e){ if (e.key==='Escape' && drawer.classList.contains('open')) close(); });

    const cartIcon = document.querySelector('.hdr-cart');
    if (cartIcon) cartIcon.addEventListener('click', function(e){ e.preventDefault(); open(); });

    window.DripurrCart = { open: open, close: close, render: render };
    getCart().then(function(c){ setBadge(c.item_count); }).catch(function(){});
  })();

  // ---------- Mobile UGC horizontal scroll carousel ----------
  (function(){
    const stage = document.querySelector('.ugc-grid');
    const dotsWrap = document.getElementById('ugcDots');
    if (!stage || !dotsWrap) return;
    const cards = Array.from(stage.querySelectorAll('.ugc-card'));
    if (!cards.length) return;
    let active = 0;
    let built = false;

    function setActive(i){
      active = Math.max(0, Math.min(cards.length - 1, i));
      cards.forEach((c, k) => c.classList.toggle('cf-active', k === active));
      dotsWrap.querySelectorAll('.ugc-dot').forEach((d, k) => d.classList.toggle('active', k === active));
    }

    function nearestIndex(){
      const mid = stage.scrollLeft + stage.clientWidth / 2;
      let best = 0, bestDist = Infinity;
      cards.forEach((c, k) => {
        const center = c.offsetLeft + c.offsetWidth / 2;
        const d = Math.abs(center - mid);
        if (d < bestDist){ bestDist = d; best = k; }
      });
      return best;
    }

    function enable(){
      if (built) return; built = true;
      dotsWrap.innerHTML = '';
      cards.forEach((_, i) => {
        const b = document.createElement('button');
        b.className = 'ugc-dot' + (i === 0 ? ' active' : '');
        b.setAttribute('aria-label', `Show video ${i + 1}`);
        b.addEventListener('click', () => {
          cards[i].scrollIntoView({ behavior:'smooth', inline:'center', block:'nearest' });
          setActive(i);
        });
        dotsWrap.appendChild(b);
      });
      let raf;
      stage.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => setActive(nearestIndex()));
      }, { passive: true });
      setActive(0);
    }

    const mq = window.matchMedia('(max-width: 767px)');
    function sync(){ if (mq.matches){ enable(); } }
    sync();
    mq.addEventListener('change', sync);
  })();

  // ---------- Benefits ----------
  const benefitsEl = document.getElementById('benefits');
  BENEFITS.forEach(t => {
    const li = document.createElement('li');
    li.className = 'benefit';
    li.innerHTML = `<span class="check"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg></span><span><b>${t.lead}</b>${t.detail ? ` <span class="b-detail">${t.detail}</span>` : ''}</span>`;
    benefitsEl.appendChild(li);
  });

  // ---------- Packages ----------
  const pkgListEl = document.getElementById('pkgList');
  function renderPkgs(){
    pkgListEl.innerHTML = '';
    PKGS.forEach(p => {
      const wrap = document.createElement('div');
      wrap.style.display = 'flex';
      wrap.style.flexDirection = 'column';

      const isActive = selectedPkg === p.id;
      const useSub = isActive && subOn && p.subPrice;
      const displayPrice = fmtP(useSub ? p.subPrice : p.price);
      const displaySave  = fmtP(useSub ? Math.round((p.compare - p.subPrice)*100)/100 : p.save);
      const freePerks = p.perks.filter(k => k.startsWith('FREE'));
      const iconForPerk = (text) => {
        const t = text.toLowerCase();
        if (t.includes('mat')) return 'https://cdn.shopify.com/s/files/1/0979/2179/4416/files/free-anti-splash-mat-icon.png?v=1782846837';
        if (t.includes('shipping')) return 'https://cdn.shopify.com/s/files/1/0979/2179/4416/files/free-shipping-icon.png?v=1782846837';
        if (t.includes('filter')) return 'https://cdn.shopify.com/s/files/1/0979/2179/4416/files/free-replacement-filters-icon.png?v=1782846837';
        if (t.includes('gift')) return 'https://cdn.shopify.com/s/files/1/0979/2179/4416/files/dripurr-free-bonus-gift-icon.png?v=1784640928';
        return null;
      };
      const shortPerk = (text) => {
        const t = text.toLowerCase();
        if (t.includes('mat')) return 'Anti-Splash Mat';
        if (t.includes('shipping')) return 'Shipping';
        if (t.includes('filter')) return 'Filters (2 months)';
        if (t.includes('gift')) return 'Bonus Gift';
        return text.replace(/^FREE\s*/i, '');
      };
      const valueForPerk = (text) => {
        const t = text.toLowerCase();
        if (t.includes('mat')) return '$22';
        if (t.includes('shipping')) return '$10';
        if (t.includes('filter')) return '$19';
        if (t.includes('gift')) return '$15';
        return null;
      };
      const btn = document.createElement('button');
      btn.className = 'pkg' + (isActive ? ' active' : '') + (p.highlight ? ' highlight' : '');
      btn.innerHTML = `
        ${p.badge ? `<span class="pkg-badge ${p.highlight ? 'pri' : ''}">${p.badge}</span>` : ''}
        <div class="pkg-row">
          <span class="radio"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg></span>
          <div class="pkg-main">
            <div class="pkg-head">
              <div style="min-width:0;flex:1">
                <h3 class="pkg-title">${p.title}${freePerks.length ? `<span class="pkg-gift-count is-inline">+${freePerks.length} Free Gift${freePerks.length>1?'s':''}</span>` : ''}</h3>
                <p class="pkg-sub">${p.subtitle}</p>
                ${freePerks.length ? `<span class="pkg-gift-count is-stacked">+${freePerks.length} Free Gift${freePerks.length>1?'s':''}</span>` : ''}
              </div>
              <div class="pkg-price">
                <div class="p">$${displayPrice}</div>
                <div class="pkg-save-row">
                  <span class="save">Save $${displaySave}</span>
                  <span class="compare">$${p.compare}</span>
                </div>
              </div>
            </div>
            <div class="perks-wrap">
              <ul class="perks">
                ${freePerks.map(k => { const ic = iconForPerk(k); const v = valueForPerk(k); return `<li class="perk-item"><div class="perk">${ic ? `<img class="perk-icon" src="${ic}" alt="" aria-hidden="true">` : ''}<span><strong>Free</strong> ${shortPerk(k)}${v ? ` <span class="perk-value-inline">· ${v} <span class="vlabel">value</span></span>` : ''}</span></div>${v ? `<div class="perk-price"><b>${v}</b> value</div>` : ''}</li>`; }).join('')}
              </ul>
            </div>
          </div>
        </div>
      `;
      btn.addEventListener('click', () => { selectedPkg = p.id; subOn = false; renderAll(); });
      wrap.appendChild(btn);

      // Subscription block under active
      if (isActive){
        const cadenceLbl = p.months === 1 ? 'every month' : (p.months === 12 ? 'every year' : `every ${p.months} months`);
        const refillPct = Math.round((p.refillOrig - p.refillPrice) / p.refillOrig * 100);
        const sub = document.createElement('div');
        sub.className = 'sub-wrap' + (subOn ? ' sub-on' : '');
        sub.style.display = 'block';
        sub.innerHTML = `
          <button class="sub-toggle" type="button">
            <span class="switch"><span class="track"></span><span class="knob"></span></span>
            <span class="sub-label">Auto-refill filters</span>
            <span class="sub-pill">Save $${p.price - p.subPrice}</span>
          </button>
          <div class="sub-details">
            <p class="sub-refill">Filter refills — <span class="sub-price"><strong>$${(n=>Number.isInteger(n)?n:n.toFixed(2))(p.refillPrice)}</strong> <s class="orig">$${(n=>Number.isInteger(n)?n:n.toFixed(2))(p.refillOrig)}</s></span> ${cadenceLbl} <span class="sub-sep" aria-hidden="true"></span> Auto-renews until you cancel <span class="sub-sep" aria-hidden="true"></span> Skip or stop online anytime <span class="sub-sep" aria-hidden="true"></span> <strong class="sub-life">${refillPct}% off filters for life.</strong></p>
          </div>
        `;
        sub.querySelector('.sub-toggle').addEventListener('click', () => { subOn = !subOn; renderAll(); });
        wrap.appendChild(sub);
      }
      pkgListEl.appendChild(wrap);
    });
  }

  // ---------- Gifts (sticky-bar thumb row) ----------
  // Bundle reward icons used in the sticky CTA — keyed by GIFTS[].label
  const GIFT_PLACEHOLDERS = {
    "Free & Fast Shipping": '<img src="https://cdn.shopify.com/s/files/1/0979/2179/4416/files/free-shipping-icon.png?v=1782846837" alt="">',
    "Filters (4-pack)":     '<img src="https://cdn.shopify.com/s/files/1/0979/2179/4416/files/free-replacement-filters-icon.png?v=1782846837" alt="">',
    "Bonus Gift!":          '<img src="https://cdn.shopify.com/s/files/1/0979/2179/4416/files/dripurr-free-bonus-gift-icon.png?v=1784640928" alt="">',
    "Anti-Splash Mat":      '<img src="https://cdn.shopify.com/s/files/1/0979/2179/4416/files/free-anti-splash-mat-icon.png?v=1782846837" alt="">'
  };
  function lockedFor(label){
    return (label === "Anti-Splash Mat" && selectedPkg !== "12m")
        || (label === "Filters (4-pack)" && selectedPkg === "1m")
        || (label === "Bonus Gift!" && selectedPkg === "1m");
  }
  const GIFT_SHORT = {
    "Free & Fast Shipping": "Shipping",
    "Filters (4-pack)":     "Extra Filters",
    "Bonus Gift!":        "Bonus Gift",
    "Anti-Splash Mat":       "Splash Mat"
  };
  const LOCK_OVERLAY = '<svg viewBox="0 0 24 24"><rect x="6" y="11" width="12" height="9" rx="1.5"/><path d="M9 11V8a3 3 0 0 1 6 0v3"/></svg>';
  let lastUnlockedSet = null; // null on first render so we don't animate the initial state
  function renderGifts(){
    const sdSegs  = document.getElementById('sdBundleThumbs');
    const smSegs  = document.getElementById('smBundleThumbs');
    const sdNames = document.getElementById('sdBundleNames');
    sdSegs.innerHTML = '';
    smSegs.innerHTML = '';
    if (sdNames) sdNames.innerHTML = '';
    let valueU = 0, valueT = 0;
    const nameParts = [];
    const currentUnlocked = new Set();
    GIFTS.forEach((g, i) => {
      const locked = lockedFor(g.label);
      valueT += g.value;
      if (!locked){ valueU += g.value; currentUnlocked.add(g.label); }
      const short = GIFT_SHORT[g.label] || g.label;
      const icon  = GIFT_PLACEHOLDERS[g.label] || '';
      const overlay = locked ? `<span class="bundle-seg-lock-overlay" aria-hidden="true">${LOCK_OVERLAY}</span>` : '';
      const html = `<div class="bundle-seg ${locked?'locked':'unlocked'}" data-gift="${g.label}" title="${g.label} — $${g.value}${locked?' (upgrade to unlock)':' (included free)'}" aria-label="${g.label}, $${g.value}, ${locked?'locked':'free'}">
        <span class="bundle-seg-wrap">
          <span class="bundle-seg-img-frame">${icon}</span>
          ${overlay}
        </span>
      </div>`;
      sdSegs.insertAdjacentHTML('beforeend', html);
      smSegs.insertAdjacentHTML('beforeend', html);
      nameParts.push(`<span class="name ${locked?'locked':''}">${short}</span>`);
    });
    if (sdNames) sdNames.innerHTML = nameParts.join('<span class="sep">·</span>');

    // Fire unlock animation on newly-unlocked tiles (skip on first render)
    if (lastUnlockedSet){
      currentUnlocked.forEach(label => {
        if (lastUnlockedSet.has(label)) return;
        document.querySelectorAll(`.bundle-seg[data-gift="${label}"]`).forEach(el => {
          el.classList.remove('just-unlocked');
          void el.offsetWidth; // restart animation if class was already there
          el.classList.add('just-unlocked');
          setTimeout(() => el.classList.remove('just-unlocked'), 850);
        });
      });
    }
    lastUnlockedSet = currentUnlocked;
    const pct = valueT ? Math.round(valueU / valueT * 100) : 0;
    const setText = (id, val) => { const el = document.getElementById(id); if (el) el.textContent = val; };
    const setWidth = (id, w) => { const el = document.getElementById(id); if (el) el.style.width = w; };
    setText('sdValue', valueU);
    setText('smValue', valueU);
    setText('sdMaxValue', valueT);
    setText('smMaxValue', valueT);
    setText('sdPct', pct);
    setText('smPct', pct);
    setWidth('sdBar', pct + '%');
    setWidth('smBar', pct + '%');
  }

  // ---------- Sticky bars ----------
  function renderSticky(){
    const p = PKGS.find(x => x.id === selectedPkg) || PKGS[1];
    const useSub = subOn && p.subPrice;
    const price = fmtP(useSub ? p.subPrice : p.price);
    const save  = fmtP(useSub ? Math.round((p.compare - p.subPrice)*100)/100 : p.save);
    document.getElementById('smMonth').textContent = p.title;
    document.getElementById('smPrice').textContent = price;
    document.getElementById('smCompare').textContent = p.compare;

    document.getElementById('sdImg').src = GALLERY[0];
    document.getElementById('sdMonths').textContent = `${p.months}-month bundle${subOn ? ' + subscription' : ''}`;
    document.getElementById('sdPrice').textContent = price;
    document.getElementById('sdCompare').textContent = p.compare;
    document.getElementById('sdSave').textContent = save;

    const ctaPriceEl = document.getElementById('ctaPrice');
    if (ctaPriceEl) ctaPriceEl.textContent = `$${price}`;
    const fcPriceEl = document.getElementById('fcPrice');
    if (fcPriceEl) fcPriceEl.textContent = price;
  }

  // ---------- FAQ ----------
  const faqListEl = document.getElementById('faqList');
  FAQS.forEach((f, i) => {
    const d = document.createElement('div');
    d.className = 'faq-item';
    d.innerHTML = `
      <button class="faq-q" type="button">
        <span class="faq-q-left">
          <span class="faq-icon-bubble">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round">${ICONS[f.icon]}</svg>
          </span>
          ${f.q}
        </span>
        <svg class="faq-chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"/></svg>
      </button>
      <p class="faq-a">${f.a}</p>
    `;
    d.querySelector('.faq-q').addEventListener('click', () => {
      openFaq = (openFaq === i) ? null : i;
      document.querySelectorAll('.faq-item').forEach((el, k) => el.classList.toggle('open', k === openFaq));
    });
    faqListEl.appendChild(d);
  });

  // ---------- Mobile: move in-column FAQ below the trust strip ----------
  if (window.matchMedia('(max-width: 1023px)').matches){
    const faqBlock = document.querySelector('.product .faq');
    const trustStrip = document.querySelector('.trust-strip');
    if (faqBlock && trustStrip){
      faqBlock.classList.add('faq--relocated');
      trustStrip.insertAdjacentElement('afterend', faqBlock);
    }
  }

  // ---------- CTAs ----------
  async function checkout(){
    const D = window.DRIPURR_PDP || {};
    if (D.fountain && D.fountain.available === false) return;
    const tier = (PKGS.find(function(p){ return p.id === selectedPkg; }) || PKGS[0]).id;
    const f = (D.filters || {})[tier] || {};
    // No live data (e.g. theme-editor preview) -> just scroll to the selector.
    if (!D.fountain || !D.fountain.variantId || !f.variantId){
      const buy = document.getElementById('buy');
      if (buy) buy.scrollIntoView({ behavior:'smooth', block:'start' });
      return;
    }
    const items = [{ id: Number(D.fountain.variantId), quantity: 1 }];
    const filterItem = { id: Number(f.variantId), quantity: 1 };
    if (subOn && f.sellingPlanId) filterItem.selling_plan = Number(f.sellingPlanId);
    items.push(filterItem);
    // Free gifts as $0 lines (made free by the "*-month gifts" automatic discounts).
    const G = D.gifts || {};
    const giftSets = {
      "1m":  [],
      "6m":  [G.mysteryGift, G.bonusFilters],
      "12m": [G.mat, G.mysteryGift, G.bonusFilters]
    };
    (giftSets[tier] || []).forEach(function(vid){
      if (vid) items.push({ id: Number(vid), quantity: 1 });
    });
    try {
      const res = await fetch(D.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      });
      if (!res.ok) throw new Error('cart add ' + res.status);
      if (window.DripurrCart) { window.DripurrCart.open(); } else { window.location.href = D.routes.cart || '/cart'; }
    } catch (err) {
      console.error('[Dripurr PDP] cart add failed', err);
      window.location.href = D.routes.cart || '/cart';
    }
  }
  (function(){
    const D = window.DRIPURR_PDP || {};
    if (D.fountain && D.fountain.available === false){
      ['ctaMain','finalCta','smCta','sdCta'].forEach(function(id){
        const b = document.getElementById(id);
        if (b){ b.disabled = true; b.style.opacity = '.55'; b.style.cursor = 'not-allowed'; b.innerHTML = 'Sold Out'; }
      });
    }
  })();
  document.getElementById('ctaMain').addEventListener('click', checkout);
  document.getElementById('finalCta').addEventListener('click', checkout);
  document.getElementById('smCta').addEventListener('click', checkout);
  document.getElementById('sdCta').addEventListener('click', checkout);

  function renderAll(){ renderPkgs(); renderGifts(); renderSticky(); }
  renderAll();
})();

// Reviews module — filterable by star rating
(function(){
  const REVIEWS = [
    { stars:5, date:"May 2026", title:"Great product!",
      by:"Adrienne W.",
      img:'<img src="https://review-images.judgeme.com/dripurr/1778801989__1778801987305-image__original.jpg?quality=80&width=1024" alt="Adrienne\'s photo of her cats with the Dripurr fountain" loading="lazy">' },
    { stars:5, date:"Aug 2026", title:"Great fountain for my kitty cat!",
      body:"She took to it right away. It would be great if you posted how to thoroughly clean the motor.",
      by:"Judith B." },
    { stars:4, date:"Aug 2026", title:"So far so good!",
      body:"My cat has been drinking from it everyday. It's easy to clean and insert filters.",
      by:"Anthony O." },
    { stars:5, date:"Aug 2026", title:"My cats were a little &ldquo;suspicious&rdquo; of this new contraption..",
      body:"It didn't take long though. Now they love it!",
      by:"Priscilla C." },
    { stars:5, date:"May 2026", title:"&#128077;&#127995;",
      by:"Adrienne W." },
    { stars:5, date:"May 2026", title:"It is great so far",
      by:"Wendy B." },
    { stars:4, date:"May 2026", title:"The Dripurr Health & Happiness Fountain Package",
      by:"Kathy L." },
    { stars:5, date:"May 2026", title:"Very quiet noice,",
      body:"my cat has been drinking lots of water out of it, hold a lot of water, good investment.",
      by:"Melanie V." },
    { stars:5, date:"May 2026", title:"Both my cata ran to the fountain, explored it and started drinking right away!",
      body:"Super easy to clean and maintain. Best fountain i have ever used!",
      by:"Craig W." },
    { stars:5, date:"Apr 2026", title:"easy to clean!",
      by:"Anonymous" },
  ];

  const grid = document.getElementById('reviewsGrid');
  const filterBar = document.getElementById('rFilterBar');
  const labelEl = document.getElementById('rFilterLabel');
  const clearBtn = document.getElementById('rClear');
  const filterBtns = document.querySelectorAll('.r-dist-row');
  // Low ratings (3 and under) collapse behind a toggle
  const distMore = document.getElementById('rDistMore');
  const distLow = document.getElementById('rDistLow');
  if (distMore && distLow){
    distMore.addEventListener('click', () => {
      const open = distLow.hidden;
      distLow.hidden = !open;
      distMore.setAttribute('aria-expanded', String(open));
      distMore.innerHTML = open ? 'Hide 3★ &amp; below' : 'Show 3★ &amp; below';
    });
  }
  const moreWrap = document.getElementById('rMoreWrap');
  const moreBtn = document.getElementById('rMore');
  const moreLabel = document.getElementById('rMoreLabel');
  const INITIAL_VISIBLE = 6;
  let activeStar = null;
  let expanded = false;

  function star(filled){
    return `<svg viewBox="0 0 24 24"${filled?'':' class="empty"'}><path d="M12 2l2.95 6.95L22 9.95l-5.5 4.92L18.18 22 12 18.27 5.82 22l1.68-7.13L2 9.95l7.05-1z"/></svg>`;
  }
  function stars(n){
    let s=''; for(let i=1;i<=5;i++) s += star(i<=n);
    return s;
  }

  function render(){
    const list = activeStar ? REVIEWS.filter(r => r.stars === activeStar) : REVIEWS;
    // When a filter is active, show all matching reviews. Otherwise respect the collapsed state.
    const showAll = !!activeStar || expanded;
    const visible = showAll ? list : list.slice(0, INITIAL_VISIBLE);

    if(list.length === 0){
      grid.innerHTML = `<div class="r-empty show">No reviews with ${activeStar} ${activeStar===1?'star':'stars'} to display right now.</div>`;
    } else {
      grid.innerHTML = visible.map(r => `
        <article class="review-card">
          <div class="review-stars" aria-label="${r.stars} stars">${stars(r.stars)}</div>
          <h3 class="review-title">${r.title}</h3>
          ${r.img ? `<div class="review-img" aria-hidden="true">${r.img}</div>` : ''}
          ${r.body ? `<p class="review-body">${r.body}</p>` : ''}
          <p class="review-by">${r.by}${r.state ? `<span class="review-state">${r.state}</span>` : ''}<span class="verified"><svg viewBox="0 0 24 24"><path d="M20 6 9 17l-5-5"/></svg><span class="verified-text">Verified buyer</span></span><span class="review-date">${r.date}</span></p>
        </article>
      `).join('');
    }
    labelEl.textContent = activeStar ? `${activeStar} ${activeStar===1?'star':'stars'}` : '';
    filterBar.classList.toggle('show', !!activeStar);
    filterBtns.forEach(b => {
      const isActive = Number(b.dataset.star) === activeStar;
      b.classList.toggle('active', isActive);
      b.setAttribute('aria-checked', isActive ? 'true' : 'false');
    });
    // Show "Show more" only when there are hidden reviews (no filter, more than 3 total)
    const hasHidden = !activeStar && list.length > INITIAL_VISIBLE;
    moreWrap.hidden = !hasHidden;
    moreBtn.classList.toggle('expanded', expanded);
    moreLabel.textContent = expanded ? 'Show fewer' : 'Show more';
  }

  filterBtns.forEach(btn => btn.addEventListener('click', () => {
    const s = Number(btn.dataset.star);
    activeStar = activeStar === s ? null : s;
    render();
  }));
  clearBtn.addEventListener('click', () => { activeStar = null; render(); });
  moreBtn.addEventListener('click', () => { expanded = !expanded; render(); });

  // Play-button delegation for review videos
  grid.addEventListener('click', e => {
    const btn = e.target.closest('.review-play');
    if (!btn) return;
    const wrap = btn.closest('.review-video-wrap');
    const video = wrap?.querySelector('video');
    if (!video) return;
    video.play();
    wrap.classList.add('playing');
  });

  render();
})();
